export default __webpack_public_path__ + "static/media/note-size_h3.8d56a6dc.svg";